var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3223",
    "data-name": "Group 3223",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.868,
    height: 14,
    viewBox: "0 0 12.868 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1786",
    "data-name": "Rectangle 1786",
    width: 12.868,
    height: 14,
    fill: "none",
    stroke: "#16161a",
    strokeWidth: 1.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3222",
    "data-name": "Group 3222",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8496",
    "data-name": "Path 8496",
    d: "M2.414,13.033H2.131A1.933,1.933,0,0,1,.2,11.1V8.273a.8.8,0,0,1,.8-.8H2.414a2.78,2.78,0,0,1,0,5.56ZM1.8,9.073V11.1a.332.332,0,0,0,.331.332h.283a1.18,1.18,0,0,0,0-2.36Z",
    transform: "translate(-0.222 -1.838)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8497",
    "data-name": "Path 8497",
    d: "M14.01,13.033h-.849a2.78,2.78,0,0,1,0-5.56h1.414a.8.8,0,0,1,.8.8v3.394A1.367,1.367,0,0,1,14.01,13.033Zm-.849-3.96a1.18,1.18,0,0,0,0,2.36h.614V9.073Z",
    transform: "translate(-2.485 -1.838)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8498",
    "data-name": "Path 8498",
    d: "M8.919,14.244H6.657a.8.8,0,0,1-.8-.8v-.565a.8.8,0,0,1,1.565-.235h1.5a2.6,2.6,0,0,0,2.593-2.593V6.657a4.856,4.856,0,1,0-9.713,0,.8.8,0,1,1-1.6,0,6.456,6.456,0,1,1,12.913,0v3.394A4.2,4.2,0,0,1,8.919,14.244Z",
    transform: "translate(-0.222 -0.222)",
    fill: "#16161a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.9bef5a07f3e283337174369897eb3f76.svg";
export { ForwardRef as ReactComponent };